export const UNPARSE_CONFIG = {
  quotes: false,
  quoteChar: '"',
  escapeChar: '"',
  delimiter: ';',
  header: true,
  newline: '\r\n',
  skipEmptyLines: false,
  columns: undefined,
};
